import { Modal } from 'almanac-ui/Modal'
import { Button } from 'components/Button'

interface Props {
  folderName: string
  onClose: () => void
  title: string
}

export const DuplicateWarningModal = ({ title, folderName, onClose }: Props) => {
  return (
    <Modal.Root>
      <Modal.Header title="Duplicate Document" />
      <Modal.Content>
        {title} is already in {folderName}.
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={onClose}>
            Ok
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
